import logo from './images/logo-white.png';
import './App.css';
import AppLayout from './components/AppLayout/AppLayout';

function App() {
  return (
    <div className="App">
      <AppLayout />
    </div>
    
  );
}

export default App;
